import { render } from "./hashtag_ingles.vue?vue&type=template&id=205281b4&scoped=true"
import script from "./hashtag_ingles.vue?vue&type=script&lang=js"
export * from "./hashtag_ingles.vue?vue&type=script&lang=js"

import "./hashtag_ingles.vue?vue&type=style&index=0&id=205281b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205281b4"]])

export default __exports__